















import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import {
    AvailabilityEditViewModel,
    AvailabilityStatus,
} from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { availabilityService, userService, storeService, shiftService } from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
})
export default class AvailabilitySavePage extends Base {
    public stores: any[];
    public availability: AvailabilityEditViewModel = {};
    public statusList: AvailabilityStatus[] = [];
    public storeShifts: any[] = [];
    public storeUsers: any[] = [];
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public userId: string = '';
    public requestProgress: boolean = false;

    public created(): void {
        this.storeId = this.$route.params.storeId ? Number(this.$route.params.storeId) : this.userSession.storeId;

        // this.storeId = Number(this.$route.params.storeId);
        this.userId = this.$route.params.userId ? this.$route.params.userId.toString() : this.userSession.sessionUserId.toString();

    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {

        if (methodName === 'cancel') {
            if (this.$route.params.teamId) {
                this.$router.push({
                    name: 'admin.teams.users',
                    params: {
                        storeId: this.$route.params.storeId,
                    },
                });
            }
            else {
                this.$router.push({
                    name: 'app.dashboard',
                });
            }


        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(false, this.$t('availability.alertInvalidForm'));
                this.resetMethodName(methodName);
                return;
            }
            this.submitAvailability();
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }

    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$parent.$t('availability.btnTitleBackToDashboard'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('availability.btnBack'), click: 'cancel', icon: 'fas fa-arrow-left' });
        this.$emit('updateToolBar', buttons);
    }

    public mounted() {
        // this.storeId = Number(this.$route.params.storeId);
        // this.userId = this.$route.params.userId ? this.$route.params.userId.toString() : this.userSession.sessionUserId.toString();

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.setFields();
        this.getAvailability();
        this.getStores();
        this.getShifts();
        this.getStoreUsers();
        this.getStatus();
    }

    public validateAvailability(): Vue & { validate: () => boolean } {
        return this.$refs.availabilityForm as Vue & { validate: () => boolean };
    }

    public async submitAvailability(): Promise<void> {
        if (this.validateAvailability().validate()) {
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                this.availability.userId = this.userId;
                await availabilityService.saveAvailability(this.availability);
                this.showAlert(true, this.$t('availability.alertAvailabilitySaved'));
                if (this.$route.params.userId.toString()) {
                    this.$router.push({
                        name: 'admin.teams.users',
                        params: {
                            storeId: this.$route.params.storeId,
                        }
                    });
                } else {
                    this.$router.push({
                        name: 'app.dashboard'
                    });
                }

            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }
    public setSelectItems(key, items) {
        const field = this.formFields.find((m) => {
            return m.key === key;
        });
        if (field) {
            field.templateOptions.items = items;
        }
    }
    public setFields(): void {
        this.formFields = [
            {
                key: 'storeId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$t('availability.availabilityFields.storeName') as string,
                    required: true,
                    disabled: true,
                    items: this.stores,
                    value: 'id',
                    text: 'dealershipName',
                    altag: 'Store Name',
                    loading: false,
                    rules: [
                        v => this.required('Store Name', v)
                    ]
                },
            },
            {
                key: 'availabilityStatus',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: this.$t('availability.availabilityFields.status') as string,
                    required: true,
                    disabled: false,
                    time: true,
                    items: this.statusList,
                    text: 'status',
                    value: 'id',
                    altag: 'Status',
                    loading: false,
                    rules: [
                        v => this.required('Status', v)
                    ]
                },
            },
            {
                key: 'shiftId',
                type: 'v-alynk-select',
                required: false,
                templateOptions: {
                    label: this.$t('availability.availabilityFields.shift') as string,
                    required: false,
                    disabled: false,
                    time: true,
                    value: 'value',
                    text: 'text',
                    items: this.storeShifts,
                    altag: 'Shift',
                    loading: false,
                    display:false
                },
            },
            {
                key: 'alternateUserId',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: this.$t('availability.availabilityFields.alternateUser') as string,
                    required: false,
                    disabled: false,
                    time: true,
                    value: 'id',
                    text: 'email',
                    items: this.storeUsers,
                    altag: 'Alternate User',
                    loading: false,
                    // rules: [
                    //     v => this.required('Alternate User', v)
                    // ]
                },
            },
            {
                key: 'alternatePhoneNumber',
                type: 'v-alynk-text-field',
                required: false,
                templateOptions: {
                    counter: 10,
                    label: this.$t('availability.availabilityFields.alternatePhoneNumber') as string,
                    mask: this.phoneMask,
                    prefix: '+1',
                    required: false,
                    disabled: false,
                    loading: false,
                    rules: [
                        v => this.PhoneNumber(v)
                    ]
                },
            },
        ];
    }
    public async getStatus(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'availabilityStatus');
            const statusList = await availabilityService.getAvailabilityStatus();
            this.statusList = statusList;
            this.setSelectItems('availabilityStatus', this.statusList);
        } finally {
            if (!this.storeId) {
                this.formlyHideSkeleton(this.formFields, 'availabilityStatus');
            }
        }
    }
    public async getShifts(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'shiftId');
            const storeShifts = await shiftService.getStoreShifts(this.storeId);
            this.storeShifts = storeShifts;
            this.setSelectItems('shiftId', this.storeShifts);
        } finally {
            if (!this.storeId) {
                this.formlyHideSkeleton(this.formFields, 'shiftId');
            }
        }
    }

    public async getStoreUsers(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'alternateUserId');
            const storeUsers = await userService.getActiveUsersByRoleInStoreAsync(
                this.storeId, 'Advisor', true,
            );

            this.storeUsers = storeUsers;

            this.setSelectItems('alternateUserId', this.storeUsers);
        } finally {
            if (!this.storeId) {
                this.formlyHideSkeleton(this.formFields, 'alternateUserId');
            }
        }
    }

    public assignStore: any;
    public async getStores(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'storeId');
            const userStores = await storeService.getUserStoresList();

            this.stores = userStores.results;


            this.setFields();
        } finally {
            if (!this.storeId) {
                this.formlyHideSkeleton(this.formFields, 'storeId');
            }
        }
    }
    public async getAvailability(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields);
            const availability = await availabilityService.getAvailability(this.storeId, this.userId);
            this.availability = availability;

            if (availability.storeId) {
                this.availability.storeId = availability.storeId.toString();
            } else {
                this.availability.storeId = this.storeId.toString();
            }
        } finally {
            this.formlyHideSkeleton(this.formFields);
        }
    }
}
